import { Box, Typography } from '@mui/material';
import AdPagesTable from './AdPagesTable';
import { AdPageType } from '../../interfaces/pages';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

type IMyPages = {
	title: string;
	type: AdPageType;
};

const MyPages: FC<IMyPages> = ({ title, type }) => {
	const { t } = useTranslation();

	return (
		<Box className={`mb-14 w-full`}>
			<Typography className="mb-6 text-base font-medium text-text-primary">{t(title)}</Typography>
			<AdPagesTable type={type} />
		</Box>
	);
};

export default MyPages;
